import React from 'react';
import { ToastContainer as ReactToastifyContainer } from 'react-toastify';

export default function ToastContainer(): JSX.Element {
  return <ReactToastifyContainer rtl={document.dir === 'rtl'} />;
}
